interface TableHeaderProps {
    elements: string[]
    empty: boolean
    onEmpty: string
    centered?: boolean
}

function TableHeader(props: TableHeaderProps) {
    return (
        <>
            {!props.empty ? (
                <div className={"w-full flex space-x-4 px-2 mb-4"}>
                    {props.elements.map((h) => (
                        <div className={"flex-1 font-bold"} key={h}>
                            {props.centered !== undefined && props.centered ? (
                                <div
                                    className={
                                        "w-full flex items-center justify-center"
                                    }>
                                    {h}
                                </div>
                            ) : (
                                <>{h}</>
                            )}
                        </div>
                    ))}
                </div>
            ) : (
                <div className={"italic"}>{props.onEmpty}</div>
            )}
        </>
    )
}

export default TableHeader
